/* ============
 * Vuex Store
 * ============
 *
 * The store of the application
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import app from './app';
import drivers from './drivers';
import lad from './lad';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    app,
    drivers,
    lad,
  },
  /**
   * If strict mode should be enabled.
   */
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js